import styled from "styled-components";

export const ProfileBodyContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 1rem;
  padding: 1rem;
  margin-top: -1.5rem;
  background: #f6f9fc;
  @media (max-width: 768px) {
    display: block;
    padding-top: 2.8rem;
    margin-top: -2.6rem;
  }
`;

export const ProfilePartContainer = styled.div`
  display: grid;
  margin-top: 0.7rem;
  height: fit-content;

  background: #ffffff;
  border-radius: 5px;
  box-shadow: 1px 2px 2px 2px #888888;

  @media (max-width: 768px) {
    display: grid;
    margin-top: 2.5rem;
  }
`;
export const ProfilePartPage = styled.div`
  display: grid;
  margin-left: 14.5rem;
  margin-right: 0.7rem;
  padding: 1rem 2rem 1rem 1rem;
  gap: 1rem;
  @media (max-width: 768px) {
    margin-left: 4.25rem;
    display: grid;
    margin-top: -2.5rem;
  }
`;

export const ProfilePartDiv = styled.div`
  display: grid;
  margin-right: 0.7rem;
  padding: 1rem 2rem 1rem 1rem;
  gap: 1rem;
  @media (max-width: 768px) {
    display: grid;
    margin-top: -2.5rem;
  }
  @media (max-width: 640px) {
    padding-right: 1rem;
  }
`;

export const Profile = styled.div`
  margin-left: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const MyProfile = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  @media (max-width: 768px) {
  }
`;
export const IconContainer = styled.div`
  color: #f47174;
  display: inline-block;
  margin-right: 1rem;
  font-size: 1.5rem;
  @media (max-width: 768px) {
  }
`;

export const MyProfileText = styled.h2`
  display: inline-block;
  @media (max-width: 768px) {
  }
`;
export const CardName = styled.p`
  @media (max-width: 768px) {
  }
`;

export const DashboardToggle = styled.div`
  display: none;
  position: absolute;
  right: 0;
  padding-left: 1rem;
  @media (max-width: 768px) {
    display: block;
  }
`;

export const ProfileEdit = styled.div`
  display: grid;
  justify-content: end;
  @media (max-width: 768px) {
    justify-content: start;
  }
`;

export const ProfileEditButton = styled.button`
  margin-right: 1rem;
  font-weight: 600;
  display: inline-block;
  padding: 0.5rem 2rem;
  background: #ffffff;
  border: 0.063rem solid black;
  border-radius: 0.2rem;
  cursor: pointer;
  height: 2rem;

  &:hover {
    border: 1px solid #232b2b;
    background-color: #232b2b;
    color: ${(props) => props.theme.color.invertedPrimary};
  }
  @media (max-width: 768px) {
  }
`;

export const ProfileSummary = styled.div`
  display: grid;
  padding: 1rem;
  grid-template-columns: 1fr;
  gap: 1rem;
  background: #ffffff;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr;
  }
  @media (max-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr;
  }
  @media (max-width: 640px) {
  }
`;

export const ProfilePicture = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 640px) {
  }
`;
export const PictureContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
  @media (max-width: 768px) {
  }
`;

export const ProfilePicSize = styled.div`
  display: flex;
  justify-content: center;
  justify-items: center;
  transition: all 0.3s ease;
  img {
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
  }
`;

export const ProfileNameContainer = styled.div`
  margin-left: 0.6rem;
  display: grid;
`;
export const Name = styled.h4``;
export const Balance = styled.div`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #7d879c;
`;
export const UserStatus = styled.div`
  margin: 0;
  font-weight: 400;
  line-height: 1.5;
  color: #7d879c;
  display: none;
  @media (max-width: 640px) {
    display: block;
  }
`;
export const BalanceTaka = styled.div`
  display: inline-block;
  color: #d23f57;
`;

export const StatusContainer = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  margin: 0;
  font-weight: 400;
  line-height: 1.5;
  color: #7d879c;
  letter-spacing: 0.2em;
  @media (max-width: 640px) {
    display: none;
  }
`;
export const ProfileOrderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 01rem;
  @media (max-width: 640px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ProfileOrder = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  gap: 0.2rem;
  box-shadow: rgb(3 0 71 / 20%) 0px 1px 3px;
  @media (max-width: 768px) {
  }
`;

export const Number = styled.h3`
  color: #d23f57;
`;
export const OrderHeading = styled.small`
  text-align: center;
  font-size: 12px;
  line-height: 1.5;
  color: #7d879c;
  text-align: center;
  text-transform: none;
  white-space: normal;
`;

export const ProfileDetails = styled.div`
  margin: 0rem 1rem;
  display: grid;
  background: #ffffff;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  padding: 1rem;
  @media (max-width: 640px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ProfileDetailsPart = styled.div`
  display: grid;
  gap: 0.5rem;
  @media (max-width: 768px) {
  }
`;
export const ProfileHeading = styled.div`
  display: grid;
  font-size: 12px;
  line-height: 1.5;
  color: #7d879c;
  text-transform: none;
  white-space: normal;
  gap: 0.5rem;
  @media (max-width: 768px) {
  }
`;
export const ProfileHeadingDetails = styled.div`
  display: grid;
  gap: 0.5rem;
  @media (max-width: 768px) {
  }
`;
export const AddressContainer = styled.div`
  margin: 1rem 1rem;
  display: grid;
  background: #ffffff;
  gap: 1rem;
  box-shadow: rgb(3 0 71 / 15%) 0px 1px 3px;
  padding: 1rem;

  @media (max-width: 768px) {
  }
`;
export const AddressButton = styled.button`
  max-width: 6.25rem;
  margin-top: 0.5rem;
  padding: 0.3rem;
  background: #ffffff;
  border: 0.063rem solid black;
  cursor: pointer;
  height: 2rem;
  &:hover {
    border: 1px solid #232b2b;
    background-color: #232b2b;
    color: ${(props) => props.theme.color.invertedPrimary};
  }

  @media (max-width: 768px) {
  }
`;

export const Line = styled.hr`
  margin-top: 1rem;
  color: #128378;
`;
export const Line1 = styled.hr`
  color: #128378;
`;
